// Standard RFC-5322-lite email validation pattern
const EmailRegPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

export default EmailRegPattern
